<template>
  <div class='table-by-column'>
    <div v-if='items.length === 0' class='table-by-column__empty'>
      {{ $t('no.technologies.found.yet') }}
    </div>
    <div v-else>
      <div class='table-by-column__header' v-if='columnTitles.length'>
        <TableHeader :column-titles='columnTitles'/>
      </div>
      <div class='table-by-column__row' v-for='(category, index) in categories' :key='index'>
        <TableColumn :category='category' :items='items'>
          <div
            slot="column-cell"
            slot-scope="columnCell"
          >
            <slot name="column-cell" :category="columnCell.category" :item="columnCell.item" />
          </div>
        </TableColumn>
        <v-divider v-if='index < categories.length - 1'/>
      </div>
    </div>
  </div>
</template>

<script>
import TableColumn from '@/components/TableByColumn/TableColumn.vue';
import TableHeader from '@/components/TableByColumn/TableHeader.vue';

export default {
  name: 'TableByColumn',
  components: { TableColumn, TableHeader },
  props: {
    columnTitles: {
      required: false,
      type: Array,
      default: () => [],
    },
    categories: {
      required: true,
      type: Array,
    },
    items: {
      required: true,
      type: Array,
    },
  },
};
</script>

<style lang='scss' scoped>
.table-by-column {
  display: flex;
  flex-direction: column;
  min-height: 194px;
  min-width: 1199px;
}
.table-by-column__empty {
  display: flex;
  justify-content: center;
  opacity: 0.6;
  color: #999;
  font-size: 30px;
  margin: auto;
  overflow: hidden;
}
</style>
<style lang="scss">
.table-by-column__row {
  .v-divider {
    margin-left: 19px !important;
    margin-right: 19px !important;
    margin-top: -3px;
    color: #E7EAEF;
  }
}
</style>
